import React, { useRef, useCallback } from 'react';

export function useDynamicRefs() {
  const refs = useRef({});

  const setRef = useCallback((key) => {
    if (!refs.current[key]) {
      refs.current[key] = React.createRef();
    }
    return refs.current[key];
  }, []);

  const getRef = useCallback((key) => {
    return refs.current[key] || null;
  }, []);

  return [getRef, setRef];
}